"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTaskReusableError = exports.ExternalTaskServiceError = exports.ExternalTaskBpmnError = void 0;
/**
 * Contains the result set for an ExternalTask that failed with a BpmnError.
 */
class ExternalTaskBpmnError {
    constructor(errorCode, errorMessage) {
        this.errorCode = errorCode;
        this.errorMessage = errorMessage;
    }
}
exports.ExternalTaskBpmnError = ExternalTaskBpmnError;
/**
 * Contains the result set for an ExternalTask that failed with a service error.
 */
class ExternalTaskServiceError {
    constructor(errorCode, errorMessage, errorDetails) {
        this.errorCode = errorCode;
        this.errorMessage = errorMessage;
        this.errorDetails = errorDetails;
    }
}
exports.ExternalTaskServiceError = ExternalTaskServiceError;
/**
 * For internal use only - A formatted error object representing an ExternalTask error.
 * Can be used by internal services who don't care if we're dealing with a Service- or BPMN error
 */
class ExternalTaskReusableError {
}
exports.ExternalTaskReusableError = ExternalTaskReusableError;
//# sourceMappingURL=ExternalTaskErrors.js.map